import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const SeaLevelElement = styled.div`
  display: inline-block;
  z-index: 100;
  color: white;
  &:hover {
    span {
      opacity: 1;
    }
  }
`;

const Text = styled.span`
  display: inline-block;
  cursor: default;
  text-transform: uppercase;
  white-space: nowrap;
  margin-right: 2em;

  @media only screen and (max-width: 750px) {
    white-space: normal;
  }
`;

const SeaLevel = ({ altitude, elevation, isMapUi }) => (
  <SeaLevelElement>
    <Text>{`Sea level  ${altitude.toFixed(1)}m`}</Text>
    { isMapUi ? null : <Text>{`Elevation  ${elevation.toFixed(1)}m`}</Text> }
  </SeaLevelElement>
);

SeaLevel.propTypes = {
  altitude: PropTypes.number.isRequired,
  elevation: PropTypes.number.isRequired,
  isMapUi: PropTypes.bool.isRequired,
};

export default connect(
    ({ altitudes, map, ui }) => ({
      altitude: altitudes.value,
      elevation: map.elevation,
      isMapUi: ui.isMapUi,
    }),
)(SeaLevel);
